import AjaxGetProducts from "../modules/AjaxGetProducts";

export default {
  init() {

    new AjaxGetProducts({
      ajaxUrl: palram.ajax_url,
      action: 'palram_get_products',
      type: 'compare',
      secure: palram.nonces.get_products,
      wrapper: document.querySelector('.compare-list'),
      loadMore: false,
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
